export const PUSH_SINGLE_ROUTER = 'pushSingleRouter';
export const REFRESH_AUTOMATION_RULE_LIST = 'refreshAutomationRuleList'; // 刷新自动化规则列表

export const REFRESH_PRESET_SCRIPT_LIST = 'refreshPresetScriptList'; // 刷新预设话术列表（新建/编辑话术后）

export const RESET_AUTOMATION_RULE_LIST = 'resetAutomationRuleList'; // 重置自动化规则列表

export const SYNC_SERVER_TIME = 'syncServerTime';

export const REFRESH_SAAS_TICKET_TAGS = 'refreshSaasTicketTags'; // 刷新SaaS工单标签
export const REFRESH_EMAIL_TICKET_TAGS = 'refreshEmailTicketTags'; // 刷新邮件工单标签

export const SAAS_TICKET_CHAT_READ = 'saasTicketChatRead'; // 客服上报SaaS工单聊天已读（详情页→列表页同步未读徽标）
export const SAAS_TICKET_NEW_MESSAGE = 'saasTicketNewMessage'; // 租户频道新客户消息广播（单例连接→列表页/详情页同步未读与排序）
